import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from '@/hooks/use-toast';
import { useQueryClient } from '@tanstack/react-query';
import { useCreatePickupAddress } from '@/hooksApi/usePickupAddress';
import LocationForm, { EMPTY_LOCATION_FORM, buildPayload } from './LocationForm';
import type { LocationFormState } from './LocationForm';

const SettingsLocationNew = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate: createAddress, isLoading: isCreating } = useCreatePickupAddress();

  const handleSave = (form: LocationFormState) => {
    const payload = buildPayload(form);
    createAddress(payload, {
      onSuccess: () => {
        toast({ title: t('success_title'), description: t('operation') });
        queryClient.invalidateQueries(['pickupAddresses']);
        navigate('/settings/locations');
      },
      onError: (error: any) => {
        const msg = error?.response?.data?.message || error?.message || t('operation_failed');
        toast({ title: t('error_title'), description: msg, variant: 'destructive' });
      },
    });
  };

  return (
    <LocationForm
      heading={t('new_address')}
      initialForm={EMPTY_LOCATION_FORM}
      isSaving={isCreating}
      onSave={handleSave}
    />
  );
};

export default SettingsLocationNew;
